<template>
	<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="topTitle"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			staticMode="true"
		></TopAppBar>
		<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1">
			<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">{{title}}</div>
			<div class="divider"></div>
			<!-- subtabs -->

		<div class="bg-documentGray">
			<div class="container container--narrow portfolio-container pdt-50 pdb-50">
				<div class="t-headline5 t-color-headlineBlack l-spacing72 t-center font-b">{{ $t("1827", { str: `${$t('3437',{first: firstName, last: lastName})}` }) }}</div>
				<div class="mgt-8 t-body1 t-color-bodyGrayA l-spacing48 t-center font-r mgt-8">{{ $t("1828") }} </div>
				<div class="pdt-24">
				<div class="d-grid-4-24 pdl-1 pdr-1">
					<div class="mdc-card  pdt-24 pdb-24 pdl-24 pdr-23 cursor-pointer" tabindex="0" @click.prevent="$router.push('/bookmarked-lesson')" @keypress.prevent="$router.push('/bookmarked-lesson')">
						<div class="d-flex justify-content-end">
							<span	class="t-headline7 font-rm l-spacing6 t-color-lectureRed bg-lectureRedBG16 portfolio-count">{{ portFolioList ? portFolioList.lessonBookmarkCount : "" }}</span>
						</div>
						<div class="mgt-21">
							<div class="pda-3"> <img src="images/portfolio/book-outline.svg" alt="" class="w-42 h-43">
							</div>
							<div class="mgt-9 t-body1 l-spacing48 l-height-22 font-r">{{ $t("1829") }}</div>
						</div>
					</div>
					<div class="mdc-card  pdt-24 pdb-24 pdl-24 pdr-23 cursor-pointer" tabindex="0" @click.prevent="$router.push('/bookmarked-mission')" @keypress.prevent="$router.push('/bookmarked-mission')">
						<div class="d-flex justify-content-end">
							<span class="t-headline7 font-rm l-spacing6 t-color-lecturePurple bg-lecturePurpleBG16 portfolio-count">
								{{ portFolioList ? portFolioList.missionBookmarkCount : "" }}
							</span>
						</div>
						<div class="mgt-21">
							<div class="pda-3">
									<img src="images/portfolio/notebook-outline.svg" alt="" class="w-42 h-43">
							</div>
							<div class="mgt-9 t-body1 l-spacing48 l-height-22 font-r">{{ $t("1830") }}</div>
						</div>
					</div>
						<div class="mdc-card  pdt-24 pdb-24 pdl-24 pdr-23 cursor-pointer" tabindex="0" @click.prevent="$router.push('/liked-lesson')" @keypress.prevent="$router.push('/liked-lesson')">
							<div class="d-flex justify-content-end">
								<span class="t-headline7 font-rm l-spacing6 t-color-lectureYellow bg-lectureYellowBG16 portfolio-count">{{ portFolioList ? portFolioList.lessonLikeCount : "" }}</span>
							</div>
							<div class="mgt-21">
								<div class="pda-3">
									<img src="images/portfolio/heart-box-outline.svg" alt="" class="w-38 h-39">
								</div>
								<div class="mgt-9 t-body1 l-spacing48 l-height-22 font-r">{{ $t("1831") }}</div>
							</div>
						</div>
						<div class="mdc-card  pdt-24 pdb-24 pdl-24 pdr-23 cursor-pointer" tabindex="0" @click.prevent="$router.push('/social-lesson')" @keypress.prevent="$router.push('/social-lesson')">
							<div class="d-flex justify-content-end">
								<span class="t-headline7 font-rm l-spacing6 t-color-lectureAqua bg-lectureAquaBG16 portfolio-count">{{ portFolioList ? portFolioList.articleLikeCount : "" }}</span>
							</div>
							<div class="mgt-21">
								<div class="pda-3">
									<img src="images/portfolio/tag-heart-outline.svg" alt="" class="w-42 h-43">
								</div>
								<div class="mgt-9 t-body1 l-spacing48 l-height-22 font-r">{{ $t("1832") }}</div>
							</div>
						</div>
				</div>
			</div>
		</div>
		<div class="divider"></div>
	</div>
<div class="container main-swiper-container">
<div class="d-flex justify-content-between align-items-baseline mgt-30 mgb-16 mgr-10 mgl-14" v-if="recommendedList && recommendedList.length > 0">
	<div class="t-color-headlineBlack t-headline10 font-b">{{ $t("1833") }}</div>
	<div
		class="t-color-secondaryBtnText t-body2 font-m cursor-pointer"
		@click.prevent="redirectToRecomendedList" @keypress.prevent="redirectToRecomendedList" tabindex="0"
		v-if="recommendedListLength > 5"
	>{{ $t("1834") }}</div>
</div>
			<div v-if="recommendedList && recommendedList.length > 0">
				<!-- Additional required wrapper -->
				<!-- <div class="swiper-wrapper" v-if="recommendedList && recommendedList.length > 0">  -->
								<!-- Slides -->
						<swiper :options="swiperOption" ref="mySwiper" class="main-swiper pdx-4 pdb-50" >
       <swiper-slide
								v-for="(recoList, k) of recommendedList"
								track-by="id"
								:key="k"
        >

									<div class="mdc-card" @click="redirectToCourseDetail(recoList.id)" @keypress="redirectToCourseDetail(recoList.id)" tabindex="0">
										<div class="mdc-card__primary-action">
											<div class=" position-relative" v-if="recoList.thumbnail">
												<img :src="recoList.thumbnail" :alt="recoList.name" />
												<div class="mdc-chip-set swiper-chip" role="grid">
													<div class="mdc-chip h-28 t-line-h-initial" role="row">
														<div class="mdc-chip__ripple"></div>
														<span role="gridcell">
															<span role="button" class="mdc-chip__primary-action">
																<span class="mdc-chip__text t-body3 pdt-2 t-color-white">{{ $t("1835", { str: recoList.lessonCount }) }}</span>
															</span>
														</span>
													</div>
												</div>
											</div>
											<div class="mgt-24">
												<div class="t-headline7 pdl-24 pdr-24 font-m t-line-2">
													{{ recoList ? recoList.name : "" }}
												</div>
											</div>
											<div class="mgt-16">
											<div class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
												v-for="(level, index4) of recoList.levels"
												:key="index4">
															{{ level.text }}
											</div>
											</div>
											<div class="mgt-2 pdl-24 mgb-16">
												<span class="font-r t-color-headlineBlack t-body6 pdr-4">by </span>
												<span class="font-r t-color-headlineBlack t-body6">
													{{ recoList && recoList.teacher && recoList.teacher.name ? recoList.teacher.name.fullName : "" }}</span>
											</div>
											<div class="d-flex align-items-baseline pdl-24 pdb-24" v-if="recoList.goods">
												<div class="t-color-headlineBlack t-body-6 pdr-4">{{  recoList.goods.currency.key || "USD" }}</div>
												<div class="t-color-headlineBlack t-headline10 pdr-8">{{ $n(recoList.goods.paymentPrice) }}</div>
												<div class="t-body1 t-color-bodyGrayB t-line-through-red" v-if="recoList.goods.paymentPrice < recoList.goods.price">{{ $n(recoList.goods.price) }}</div>
											</div>
											<div class="t-headline5" v-else>  {{ $t("872") }} </div>
										</div>
									</div>

						</swiper-slide>
      </swiper>
							<!-- </div> -->
					</div>
				</div>
			</main>
		</div>
	</div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import portfolioApi from "@/api/portfolioApi.js";
import mainApi from "@/api/mainApi.js";
import memberApi from "@/api/memberApi.js";
import {mapState} from 'vuex'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {
	name: "Portfolio",

	data() {
		return {
			userDetails:null,
			topTitle: localStorage.getItem('brandName'),
			leftBtnMethod: () => {
				this.$router.go(-1);
			},
			portFolioList: null,
			swiperOption: {
				slidesPerView: "auto",
				spaceBetween: 20,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				translate: 0,
				autoHeight: false,
			},
			memberData: null,
			firstName: null,
			lastName: null,
			recommendedList: null,
			recommendedListLength: 0
		};
	},

	components: {
		swiper,
		swiperSlide,
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin],

	watch: {
		$route(to, from) {},
	},

	computed: {
		// swiper define
		swiper() {
			return this.$refs.mySwiper.swiper;
		},

		...mapState({
				memberDetail : state =>state.member.memberDetail,
		}),

	},

	mounted() {
		//this.setTopAppBarBackSearch(this.$t("1826"));
		this.setTopAppBarHomeBlank(this.$t('1826'));
		this.fetchData();
		this.userDetails =localStorage.getItem("memberName");
		memberApi.getMemberInfo().then((response) => {
        // this.memberName = response.data.data.name.fullName;
        	this.firstName = response.data.data.name.first;
        	this.lastName = response.data.data.name.last;
      	}).catch((err) => {});
	},
	methods: {
		fetchData() {
			// this.memberData = this.memberDetail;
			// this.firstName = this.memberData? this.memberData.name.first: "";
			// this.lastName = this.memberData? this.memberData.name.last: "";
			// this.profileImage = this.memberData? this.memberData.profile.resourceUri: "";
			// 채팅 룸 정보(get chatting room list)
			portfolioApi
				.portfolioList()
				.then((response) => {
					this.portFolioList = response.data.data;
					//this.recommendedList = this.portFolioList.purchaseOnlineDegreeDtos
					//console.log('recommendedList',this.recommendedList)
					// let list = response.data.data.content;

					// if (!list.length) {
					//     this.isNoData = true
					// }
				})
				.catch((err) => {});
			let params = {
				size: 5,
				sort: 'groupId,desc'
			};
			mainApi
				.fetchRecommendedList(params)
				.then((response) => {
					this.recommendedList = response.data.data.content;
					if (response.data.data.content) {
						this.recommendedListLength = response.data.data.totalElements;
						//console.log('recommendedListLength',response.data.data.totalElements)
					}
					//this.$hideLoading()
				})
				.catch((err) => {
					let responseData = err.response.data.meta;
					this.$error({ content: responseData.errMsg }).then(() => {});
				});
		},

		redirectToCourseDetail(id) {
			this.$router.push("/degree/" + id + "?type=ListNew");
		},

		redirectToRecomendedList() {
			localStorage.setItem("portfolio", "backtoPortfolio");
			this.$router.push("/degree?type=ListRecommened");
		},
	},
};
</script>
